import { InterviewAssignedModal } from './InterviewAssignedModal';

export default InterviewAssignedModal;